var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "form grid",
      attrs: { action: _vm.content.url, method: "post" }
    },
    [
      _c(
        "div",
        { staticClass: "form--fieldset-row" },
        _vm._l(_vm.protectedFieldsets, function(fieldset, fieldsetIdx) {
          return _c(
            "fieldset",
            { key: fieldsetIdx, staticClass: "form--fieldset" },
            [
              _c("div", { staticClass: "grid--row form--legend-row" }, [
                fieldset.name
                  ? _c("div", { staticClass: "grid--col form--legend" }, [
                      _c("div", { staticClass: "form--fieldset-title" }, [
                        _c("legend", {
                          domProps: { textContent: _vm._s(fieldset.name) }
                        })
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "grid--col form--fields" }, [
                  _c(
                    "div",
                    { staticClass: "form--field-row" },
                    _vm._l(fieldset.fields, function(field, fieldIdx) {
                      return _c(
                        field.component,
                        _vm._b(
                          {
                            key: "field.id",
                            tag: "component",
                            staticClass: "form--field",
                            class: _vm.bemAdd(field.field_facet, "field"),
                            on: { "recaptcha-submit": _vm.handleFormSubmit },
                            model: {
                              value: field.val,
                              callback: function($$v) {
                                _vm.$set(field, "val", $$v)
                              },
                              expression: "field.val"
                            }
                          },
                          "component",
                          _vm.bindFieldData(field),
                          false
                        )
                      )
                    })
                  )
                ])
              ])
            ]
          )
        })
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49191135", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49191135","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/cms-plugins/base-form/index.vue
// module id = 289
// module chunks = 5